import { useCallback } from "react";

import useTypedContext from "hooks/useTypedContext";
import { Action, Context } from "types/generated";
import { AccessResult, hasAtLeastOneRequiredAction, NO_ACCESS_MESSAGE } from "utils/access";
import { AccountContext } from "views/AccountWrapper";

const DELETE_CONTEXT_ACCESS_TYPES = [Action.SpaceAdmin, Action.ContextDelete];

const useCanDeleteContext = (): ((context: Context) => AccessResult) => {
  const { viewer } = useTypedContext(AccountContext);

  return useCallback(
    (context: Context) => {
      if (context.plugin?.id) {
        return {
          result: false,
          message: `This context is managed by the plugin "${context.plugin.name}" and can't be deleted.`,
        };
      }

      if (viewer.admin) {
        return { result: true };
      }

      const spaceId = context.space || context.spaceDetails.id;

      const hasAccess = hasAtLeastOneRequiredAction(DELETE_CONTEXT_ACCESS_TYPES, viewer, spaceId);

      if (hasAccess) {
        return { result: true };
      }

      return { result: false, message: NO_ACCESS_MESSAGE };
    },
    [viewer]
  );
};

export default useCanDeleteContext;
